module.exports = __webpack_public_path__ + "img/sandy_cheeks.73ebae58.jpg";